import { Route } from 'react-router-dom';

import type { IDealHistoryActivity } from '../types/IDealHistoryActivity';
import { getAllRoutes } from '../utils/routes';

import { ActivityRouteContainerCompact } from '@makemydeal/dr-dash-components';
import DealHistoryActivityInterstate from './DealHistoryActivity.interstate';

const Root = (props: IDealHistoryActivity) => {
    const { root } = getAllRoutes(props.baseRoute);

    return (
        <ActivityRouteContainerCompact data-testid="activities-deal-history-container" className="activities-deal-history">
            <Route path={root} component={DealHistoryActivityInterstate} />
        </ActivityRouteContainerCompact>
    );
};

Root.displayName = 'DealHistoryActivity';

export default Root;
